import React from 'react';

//import { snackbarInfo } from '@readcloud/common-ui';

import { maxDictionaryQueryLength } from '../../../constants';
import {
  LearningToolbarActions,
  LearningToolbarPopover,
} from './LearningToolbarActions';

import { useTTS } from '../../../hooks/useTTS';

import {
  applicationActions,
  jobsActions,
  textSelectionActions,
  useAppDispatch,
} from '@readcloud/state';
import copy from 'copy-to-clipboard';
import { trackEvent, uuidV4 } from '@readcloud/common';
const unnavailableTooltip = 'Internet connectivity required';

export const LearningToolbar = (props: {
  positionFixed?: boolean;
  range?: Range;
  selectedText?: string;
  selectionLocation?: string;
  location?: string;
  className?: string;
  selecting?: boolean;
  container?: HTMLElement;
  tts?: (params: { text: string }) => Promise<string>;
  disableCopy: boolean;
  disableInfo: boolean;
  disableDictionary: boolean;
  disableTTS: boolean;
  disableImmersive: boolean;
  currentlyFilteringText?: string | undefined;
  saveAnnotationFilter?: (annoFilter: string) => void;
  currentAuthor: string;
  filterUsers?: string[];
  setUserFilter: (users: string[]) => void;
  filterAnnotationBy: (filter: string, users: string[]) => void;
  openConfirmation?: boolean | undefined;
  setConfirmation?: (openDialog: boolean) => void;
  isOnline: boolean;
  checkOnline: () => boolean;
}) => {
  const dispatch = useAppDispatch();

  const handleCopyClick = () => {
    trackEvent('Webapp/CopyBookTextClicked', {});
    copy(
      props.selectedText
        ?.toString()
        .trim()
        .replace(/[^\S ]+/g, ' ')
    );
    dispatch(
      jobsActions.addJob({ id: uuidV4(), description: 'Copied to Clipboard' })
    );
  };

  const handleBookmarkClick = () => {
    dispatch(applicationActions.updateApplication({ bookmarkModalOpen: true }));
  };

  const handleDictionaryClick = () => {
    if (props.isOnline) {
      dispatch(
        applicationActions.updateApplication({ dictionaryPopoverOpen: true })
      );
    } else {
      console.log('offline');
      dispatch(
        applicationActions.updateApplication({ offlineModalOpen: true })
      );
    }
  };

  const handleNoteClick = () => {
    dispatch(
      applicationActions.updateApplication({ annotationAddModalOpen: true })
    );
  };

  const { playingAudio, handleListen, handleStopAudio } = useTTS({
    text: props.selectedText,
    disabled: props.disableTTS,
  });

  const handleImmersiveReaderClick = React.useCallback(() => {
    if (props.isOnline) {
      dispatch(
        textSelectionActions.updateSelectionData({
          selectedText: props.selectedText?.replace(/[^\S ]+/g, ' '),
        })
      );
      dispatch(
        applicationActions.updateApplication({ immersiveReaderModalOpen: true })
      );
    } else {
      dispatch(
        applicationActions.updateApplication({ offlineModalOpen: true })
      );
    }
  }, [props.isOnline, props.selectedText]);

  return (
    <>
      <LearningToolbarPopover
        open={
          !!props.selectedText &&
          !!props.range &&
          //pdf's pass this to check it's page's learningToolbar should be rendered, epubs don't pass this and it should always be rendered.
          (!props.location || props.selectionLocation === props.location)
        }
        positionFixed={props.positionFixed}
        className={props.className}
        hidden={props.selecting}
        container={props.container}
        boundingRectElement={props.range}
      >
        <LearningToolbarActions
          outerContainer={props.container}
          disableTTS={props.disableTTS}
          disabledInfo={props.disableInfo}
          disabledInfoTooltip={unnavailableTooltip}
          disabledDictionary={props.disableDictionary}
          disabledDictionaryTooltip={unnavailableTooltip}
          disableCopy={props.disableCopy}
          disableImmersive={props.disableImmersive}
          onBookmarkClick={handleBookmarkClick}
          onDictionaryClick={
            props.selectedText?.length &&
            props.selectedText?.length < maxDictionaryQueryLength
              ? handleDictionaryClick
              : undefined
          }
          onNoteClick={handleNoteClick}
          onCopyClick={handleCopyClick}
          onListenClick={handleListen}
          onListenStopClick={handleStopAudio}
          listening={!!playingAudio}
          currentlyFilteringText={props.currentlyFilteringText}
          saveAnnotationFilter={props.saveAnnotationFilter}
          currentAuthor={props.currentAuthor}
          filterUsers={props.filterUsers}
          setUserFilter={props.setUserFilter}
          filterAnnotationBy={props.filterAnnotationBy}
          openConfirmation={props.openConfirmation}
          setConfirmation={props.setConfirmation}
          isOnline={props.isOnline}
          onImmersiveClick={handleImmersiveReaderClick}
        />
      </LearningToolbarPopover>
    </>
  );
};
